<template>
    <v-row dense class="mx-1">
        <v-col cols="10" class="">
            <v-row justify="center">
                <h5>個人情報同意書状態</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row dense no-gutter justify="center" class="mx-1">
                <v-col cols="6" class="">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">送信済み</span>
                        <v-checkbox v-model="piaStatus.sent"></v-checkbox>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">契約済み</span>
                        <v-checkbox v-model="piaStatus.signed"></v-checkbox>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="2" class="">
            <v-row justify="center">
                <h5>同意書作成</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row justify="center" align="center">
                <v-col cols="12">
                    <v-row justify="center">
                        <v-btn x-small class="mt-3" @click="downloadPIA()">PDFを作成</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
/* eslint-disable no-console */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
    name:'personalInfoAgreement',
    props:[
        'researcher',
    ],
    data(){
        return{
            piaStatus:{
                sent:false,
                signed:false,
            }
        }
    },
    methods:{
        downloadPIA(){
            pdfMake.fonts = {
                GenShin: {
                    normal: 'GenShinGothic-Normal-Sub.ttf',
                    bold: 'GenShinGothic-Normal-Sub.ttf',
                    italics: 'GenShinGothic-Normal-Sub.ttf',
                    bolditalics: 'GenShinGothic-Normal-Sub.ttf',
                },
            };
            const defaultStyle = 'GenShin';

            // PDF出力する内容の定義
            const dateOfCreation = new Date();
            const docDefinition = {
                content: [
                    {
                        text: '個人情報の取扱いについて\n(個人事業主様用　同意書)',
                        style: 'header',
                        alignment: 'center'
                    },
                    {   
                        type:'none',
                        ul: [
                                ['\n\n1. 事業者名及び個人情報保護管理者',
                                    {   
                                        type:'none',
                                        ol:[
                                            '株式会社ＴＰＯ',
                                            '個人情報保護管理者：山崎　絢乃'
                                        ]
                                    }
                                ],
                                ['\n2. 個人情報の利用目的について',
                                    {   
                                        type:'none',
                                        ol:[
                                            '当社は、貴殿からお預かりした個人情報は、次の目的の範囲内で取り扱います。次の目的以外で個人情報を利用する場合は、改めてその利用目的をお知らせし、同意を得ることとします。',
                                            {   
                                                type:'none',
                                                ol:[
                                                    '(1)当社において貴殿に業務を委託するため。',
                                                    '(2)貴殿との契約、注文、請求等の事務に利用するため',
                                                    '(3)貴殿と連絡を取るため',

                                                ]
                                            }
                                        ]
                                    }
                                ],
                                ['\n3. 第三者提供について',
                                    {   
                                        type:'none',
                                        ol:[
                                            '以下の場合には、取得した個人情報を第三者に提供いたします。これ以外には本人の同意がない限り、取得した個人情報を第三者に提供することはありません。',
                                            {   
                                                type:'none',
                                                ol:[
                                                    '(1)当社取引先へ貴殿を紹介する場合',
                                                    '(2)当社取引先との事務手続き上、貴殿の情報を提供する必要がある場合',
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                ['\n4. 委託について',
                                    {   
                                        type:'none',
                                        ol:[
                                            '上記の利用目的の範囲内で個人情報の取扱いの一部又は全部を委託することがあります。委託する際には、十分な個人情報の保護水準を満たしている者を選定し、契約書を締結し、委託する個人情報の安全管理が図られるよう、必要且つ適切な監督を行います。',
                                        ]
                                    }
                                ],
                                ['\n5. 個人情報の提供の任意性について',
                                    {   
                                        type:'none',
                                        ol:[
                                            '当社が提出を求める個人情報につき、提供に応じるか否か任意ですが、提供頂けない個人情報がある場合、利用目的に該当する業務に支障が生じる恐れがあります。',
                                        ]
                                    }
                                ],
                                ['\n6. 個人情報の開示等及び苦情・相談について',
                                    {   
                                        type:'none',
                                        ol:[
                                            '当社は、提供頂いた保有個人データ(開示対象となる個人情報)に関する利用目的の通知、開示、訂正、追加、削除、利用の停止、消去又は第三者提供の停止(以下「開示等」という)に関わる請求及び苦情・相談(開示等に関わる請求についての苦情・相談も含む)につき迅速に対応します。下記の窓口までお申し出ください。',
                                        ]
                                    }
                                ],
                        ]
                    },
                    {
                        text: '個人情報苦情相談窓口責任者　　山崎　絢乃',
                        margin: [ 40, 10, 0, 0 ],
                        style: 'text',
                        alignment: 'start'
                    },
                    {
                        text: 'TEL：03-6271-4635                                       以上',
                        margin: [ 40, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'start'
                    },
                    //divider
                    {pageBreak: 'after', canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 2 }]},

                    {
                        text: `日付    ${dateOfCreation.getFullYear()}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {   
                        type:'none',
                        ol:[
                            '株式会社ＴＰＯ',
                            '代表取締役　マニヤン麻里子　様',
                            '\n私は、上記の事項に同意した上で、私の個人情報を提供致します。'
                        ]
                    },
                    {
                        text: `\n氏名 ${' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+this.researcher.name[1]+' '+this.researcher.name[0]}`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },
                    {
                        text: `住所 ${' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+this.researcher.address.postalCode+' '+this.researcher.address.address}`,
                        margin: [ 240, 10, 0, 10 ],
                        style: 'text',
                        alignment: 'left'
                    },

                ],
                defaultStyle: {
                    font: defaultStyle,
                },
                styles: {
                    header: {
                        fontSize: 18,
                    },
                    subheader: {
                        fontSize: 10.5,
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                },
            };

            // pdfMakeでのPDF出力
            pdfMake.createPdf(docDefinition).open();
        }
    },
}
</script>>